import * as React from 'react';
import { Stack, Box, Typography,Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const SyledButton = styled(Button)({
  background: 'white', borderRadius: '20px',
  padding: '5px 30px',
  fontSize: '14px',
  color: 'black',
  '&:hover': {
    background: '#54B948',
    color: 'white',
    
  }
});


export default function Footer({disconnect}) {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0 40px' }}>

      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Typography component="div">
          To remove connection with SKYPAD, click the button.
        </Typography>
        <SyledButton variant="outlined" size="small"  onClick={() => disconnect()}>
          Remove all SKYPAD Access
        </SyledButton>
      </Stack>

    </Box>
  );
}
